module.exports = __webpack_public_path__ + "media/old_images/app-promo-b817ce94.png";